export const MESSAGE_PAGE_SIZE = 20;
export const RECONCILE_PAGE_SIZE = 100;
export const LOAD_PREVIOUS_MESSAGES_SCROLL_THRESHOLD = 400;
export const CIRCLE_AI_MESSAGE_SCROLL_VIEW_ID = "circle-ai-message-scroll-view";
export const CIRCLE_AI_CONVERSATION_CHANNEL = "CircleAi::ConversationChannel";
export const STALL_TIMEOUT_MS = 30000;
export const STALL_CHECK_INTERVAL_MS = 3000;

export const CIRCLE_AI_CLAUDE_STATUS_URL =
  "/internal_api/circle_ai/claude_status";
export const CIRCLE_AI_CLAUDE_STATUS_STALE_TIME_MS = 60_000;
export const CLAUDE_STATUS_PAGE_URL = "https://status.claude.com";
export const CIRCLE_AI_ONBOARDING_MESSAGE_SCROLL_VIEW_ID =
  "circle-ai-onboarding-message-scroll-view";

// Row/card action affordances (e.g. the delete menu) reveal on hover/focus on
// hover-capable devices, and stay visible on touch — which has no hover — so
// the menu remains discoverable on mobile. The popup-open case keeps the
// trigger visible on any device while its menu is open.
export const CARD_ACTIONS_REVEAL_CLASSES =
  "pointer-events-auto opacity-100 [@media(hover:hover)]:pointer-events-none [@media(hover:hover)]:opacity-0 [@media(hover:hover)]:group-hover:pointer-events-auto [@media(hover:hover)]:group-hover:opacity-100 [@media(hover:hover)]:group-focus-within:pointer-events-auto [@media(hover:hover)]:group-focus-within:opacity-100 has-[[data-popup-open]]:pointer-events-auto has-[[data-popup-open]]:opacity-100";
